import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <Link to="/" aria-label="Helpr Home">
              <Logo size={28} withWordmark={true} className="text-white" />
            </Link>
            <p className="text-gray-400 leading-relaxed">
              Turn website visitors into hot leads with our on-site assistant and done-for-you lead generation system.
            </p>
            {/* Social links removed */}
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-white">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-blue-400 transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-blue-400 transition-colors">About</Link></li>
              
            </ul>
          </div>

          {/* Services */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-white">Services</h4>
            <ul className="space-y-2">
              <li><Link to="/demo" className="hover:text-blue-400 transition-colors">Lead Capture Assistant</Link></li>
              <li><Link to="/pricing" className="hover:text-blue-400 transition-colors">Google Ads Management</Link></li>
              <li><Link to="/contact" className="hover:text-blue-400 transition-colors">High-Converting Landing Pages</Link></li>
              <li><Link to="/pricing" className="hover:text-blue-400 transition-colors">SMS Notifications</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-heading font-semibold text-white">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-blue-400" />
                <a href="tel:734-478-4790" className="hover:text-blue-400 transition-colors">
                  (734) 478-4790
                </a>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-blue-400" />
                <a href="mailto:luke@leadhelpr.com" className="hover:text-blue-400 transition-colors">
                  luke@leadhelpr.com
                </a>
              </div>
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-blue-400 mt-0.5" />
                <span>Built for 24/7 small to midsize home service businesses</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2025 Helpr. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}


